<template>
    <div>
        <v-autocomplete
            v-model="cnasAgency"
            :items="cnasAgencyStore.cnasAgencies"
            item-value="id"
            item-text="name"
            :label="label"
            outlined
            dense
            :multiple="multiple"
            :chips="multiple"
            :deletable-chips="!readonly"
            :color="inputColor"
            :background-color="backgroundColor"
            :readonly="readonly"
            :loading="loading"
            :clearable="!(readonly || notClearable)"
            @input="input"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import axios from "axios";
import {useCnasAgencyStore} from "@/stores/CnasAgency";
import {useSecurityStore} from "@/stores/Security";

export default {
    name: "StrCnasAgencyAutocomplete",
    props: {
        value: [Number, Array],
        readonly: Boolean,
        notClearable: Boolean,
        multiple: Boolean,
        setDefault: Boolean,
        label: String,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const securityStore = useSecurityStore();

        const cnasAgency = ref(null);
        const cnasAgencyStore = useCnasAgencyStore();

        if(props.setDefault) {
            cnasAgency.value = securityStore.userContext.defaultCnasAgency;
            emit('input', cnasAgency.value);
        }

        function findAll() {
            loading.value = true;
            axios.get('/cnasAgencies').then(response => {
                cnasAgencyStore.setCnasAgencies(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        watch(() => props.value, () => {
            if (props.value)
                cnasAgency.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            loading,
            inputColor,
            backgroundColor,
            cnasAgency,
            cnasAgencyStore,
            input,
        }
    }
}
</script>

<style scoped>

</style>